import { queryOptions, useQuery } from '@tanstack/react-query';
import { fetchOrderHubOrders } from '@/api/order-hub';
import type { OrdersHubListParams } from '../-utils/listParams';
import { buildOrdersHubQs } from '../-utils/listParams';

export const ordersHubKeys = {
  all: ['orders-hub'] as const,
  list: (params: OrdersHubListParams) =>
    [...ordersHubKeys.all, 'list', params] as const,
  lines: (orderId: string) => [...ordersHubKeys.all, 'lines', orderId] as const,
  detail: (id: string) => [...ordersHubKeys.all, 'detail', id] as const,
};

export function ordersHubQueryOptions(params: OrdersHubListParams) {
  return queryOptions({
    queryKey: ordersHubKeys.list(params),
    queryFn: () => fetchOrderHubOrders(buildOrdersHubQs(params)),
    staleTime: 30_000,
  });
}

export function useOrdersHubList(params: OrdersHubListParams) {
  return useQuery(ordersHubQueryOptions(params));
}
